/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Credit_DecisionsInputs */

const en_nav_credit_decisions = /** @type {(inputs: Nav_Credit_DecisionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Credit decisions`)
};

/**
* | output |
* | --- |
* | "Credit decisions" |
*
* @param {Nav_Credit_DecisionsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const nav_credit_decisions = /** @type {((inputs?: Nav_Credit_DecisionsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Credit_DecisionsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_nav_credit_decisions(inputs)
});